<template>
  <div>
    <b-modal :id="theme" visible no-close-on-backdrop no-close-on-esc hide-header-close hide-footer
      header-class="p-0 border-0" body-class="px-4 pt-5 pb-0" size="xl" title="リハビリテーション">
      <Loader :loading="loading">
        <div>
          <div class="row" v-show="mode === 1">
            <div class="col-8">
              <h2 class="text-center mb-4 font-weight-semibold">レクチャー動画</h2>
              <div class="video-container p-3"
                style="background-image: linear-gradient(to bottom right, #3A529A , #5899D9); border-radius: 10px;">
                <video v-if="guideVideo?.path" class="p-0 m-auto w-100" :src="guideVideo.path" controls
                  style="object-fit: contain; border-radius: 10px;"></video>
              </div>
            </div>
            <div class="col-4">
              <h2 class="text-center mb-4 font-weight-semibold">リハビリ部位選択</h2>
              <div class="text-center">
                <div v-for="item in suggestionTypes" :key="item.value">
                  <button type="button" class="btn font-weight-semibold mb-3 px-5 w-100" @click="type = item.value"
                    :class="[Number(type) === item.value ? 'btn-toggle' : 'btn-outline-toggle']">
                    {{ item.name }}
                  </button>
                </div>
              </div>
            </div>

            <div class="modal-footer mt-3">
              <div class="row w-100">
                <div class="col-2 offset-8">
                  <button class="btn btn-light w-100" type="button" @click="closeModal()">閉じる</button>
                </div>
                <div class="col-2">
                  <button class="btn btn-lyg w-100 font-weight-semibold" type="button"
                    :disabled="loading || locked || !type" @click="callAiGetSuggestions()">次へ</button>
                </div>
              </div>
            </div>
          </div>

          <div v-show="mode === 2">
            <div>
              <h2 class="text-center mb-3 font-weight-semibold">AIリハビリ候補</h2>
            </div>
            <div>
              <div class="text-center">
                  AIが提案したメニューの中から表示する動画を最大3つ選択できます
              </div>
            </div>
            <div class="pt-4">
              <div style="max-height: 300px; min-height: 70px; overflow-y: auto; overflow-x: hidden">
                <div class="row">
                  <div v-for="suggestVideo in suggestVideos" :key="suggestVideo.id" class="col-6 col-lg-4">
                    <div class="mt-3">
                      <div class="rounded-3 border-3 p-3" style="border-color: #666">
                        <div class="row">
                          <div class="col-12 col-xl-6 text-center">
                            <a @click="openVideoPopup(suggestVideo.path)">
                              <img class="w-100" :src="suggestVideo.thumbnail" onerror="this.src='/img/noinage.jpg';"
                                :alt="suggestVideo.name">
                            </a>
                          </div>
                          <div class="col-12 col-xl-6">
                            <div class="mt-2 mt-xl-0">
                              <h6 class="font-weight-semibold video-title-241101">{{ suggestVideo.name }}</h6>
                              <div>{{ suggestVideo.duration ? `${calcMinutes(suggestVideo.duration)}分` : '' }}</div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div v-if="hasError('suggestions')" class="text-center py-3">
                    <span class="d-inline-block text-danger ms-3">{{ errors.suggestions }}</span>
                  </div>
                </div>
              </div>
              <hr>
              <div class="row">
                <div class="col-6">
                  <h6>
                    リハビリメニュー名*
                    <span v-if="hasError('title')" class="d-inline-block text-danger ms-3">{{ errors.title }}</span>
                  </h6>
                  <input type="text" maxlength="200" class="form-control" placeholder="リハビリメニュー_20240722"
                      minlength="200" v-model="title" required>
                </div>
                <div class="col-6">
                  <div class="row">
                    <div class="col-6 12 col-xl-4">
                      <h6>部位</h6>
                      <div class="font-weight-semibold fs-5 mt-3">{{ getSuggestionTypeName() }}</div>
                    </div>
                    <div class="col-6 12 col-xl-4">
                      <h6>合計時間</h6>
                      <div class="font-weight-semibold fs-5 mt-3">{{ calcTotalMinutes() }}分</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="modal-footer mt-0 border-0">
              <div class="container-fluid">
                <div class="row">
                  <div class="col-4 col-lg-2 offset-lg-6">
                    <button class="btn btn-light w-100" type="button" @click="closeModal()">閉じる</button>
                  </div>
                  <div class="col-4 col-lg-2">
                    <button class="btn btn-outline-lyg w-100" type="button" @click="mode = 3">動画を変更</button>
                  </div>
                  <div class="col-4 col-lg-2">
                    <button class="btn btn-lyg w-100 font-weight-semibold" type="button"
                      :disabled="loading || locked" @click="saveSuggestions()">決定</button>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div v-show="mode === 3">
            <div>
              <h2 class="text-center mb-3 font-weight-semibold">リハビリ動画リスト</h2>
            </div>
            <div>
              <div class="text-center">
                  動画は最大3つ選択できます
              </div>
            </div>
            <div class="pt-4" style="max-height: 490px; overflow-y: auto; overflow-x: hidden">
              <div class="row">
                <div v-for="suggestVideo in selectableVideos" :key="suggestVideo.id" class="col-6 col-lg-4">
                  <div class="mt-3" @click="toggleSelectedVideos(suggestVideo.no)" >
                    <div class="rounded-3 border-3 p-3" style="border-color: #666"
                      :class="{'border-lyg bg-lyg':  selectedVideoNos.includes(suggestVideo.no)}">
                      <div class="row">
                        <div class="col-12 col-xl-6 text-center">
                          <a @click="openVideoPopup(suggestVideo.path)">
                            <img class="w-100" :src="suggestVideo.thumbnail" onerror="this.src='/img/noinage.jpg';"
                              :alt="suggestVideo.name">
                          </a>
                        </div>
                        <div class="col-12 col-xl-6">
                          <div class="mt-2 mt-xl-0">
                            <h6 class="font-weight-semibold video-title-241101">{{ suggestVideo.name }}</h6>
                            <div>{{ suggestVideo.duration ? `${calcMinutes(suggestVideo.duration)}分` : '' }}</div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="modal-footer mt-0 border-0">
              <div class="container-fluid">
                <div class="row">
                  <div class="col-4 offset-4 col-lg-2 offset-lg-8">
                    <button class="btn btn-light w-100" type="button" @click="mode = 2">キャンセル</button>
                  </div>
                  <div class="col-4 col-lg-2">
                    <button class="btn btn-lyg w-100 font-weight-semibold" type="button"
                      :disabled="loading || locked" @click="selectSuggestions()">選択決定</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Loader>
      <VideoPopup :videoURL="videoUrl" @closeModal="showVideoFlag = false" :isShow="showVideoFlag" />
    </b-modal>
  </div>
</template>

<script>
import api from "@/api";
import Loader from "@/components/widgets/loader.vue";
import VideoPopup from "@/components/widgets/video-popup.vue";
import moment from "moment";
import {isEmpty} from 'lodash';
import {keys, retries} from '@/caches/memory';
import {calcTwoStep} from "@/helpers/Util";
import {REHAB_VIDEO_SUGGESTION_TYPE} from "@/constant";

const GUIDE_VIDEO_CODE = '000';
const SUGGEST_VIDEO_TYPE = 3;

export default {
  components: {Loader, VideoPopup},
  props: ['user', 'rehabVideoSuggestionId'],
  data() {
    return {
      loading: true,
      locked: true,
      allRehabVideos: [],
      rokomo: null,
      medical: null,
      type: null,
      title: '',
      suggestVideoNos: [],
      selectedVideoNos: [],
      mode: 1,
      errors: {},
      showVideoFlag: false,
      videoUrl: null,
    };
  },
  computed: {
    isEdit() {
      return !!this.rehabVideoSuggestionId;
    },
    theme() {
      return this.$store.state.theme;
    },
    guideVideo: function () {
      return this.allRehabVideos.find(i => i.code === GUIDE_VIDEO_CODE);
    },
    suggestVideos: function () {
      return this.allRehabVideos.filter(i => this.suggestVideoNos.includes(i.no));
    },
    selectableVideos: function () {
      return this.allRehabVideos.filter(i => i.type === SUGGEST_VIDEO_TYPE);
    },
    suggestionTypes: function () {
      return REHAB_VIDEO_SUGGESTION_TYPE;
    }
  },
  async created() {
    await this.getAllRehabVideos();

    if (this.isEdit) {
      this.mode = 2;
      await this.RehabVideoSuggestion();
    } else {
      await this.getLastRokomo();
      await this.getMedicalByUserId();
    }

    this.loading = false;
    this.locked = false;
  },
  methods: {
    async getAllRehabVideos() {
      this.allRehabVideos = await retries(keys.ALL_REHAB_VIDEOS, async () => {
          const res = await api.getAllRehabVideos();
          if (res.status === 200) {
            return res.data;
          }
      });
    },
    async getLastRokomo() {
      const res = await api.lastRokomo(this.user.id);
      if (res.status === 200 && res.data) {
        this.rokomo = res.data;
        this.rokomo.two_step_level = calcTwoStep(this.rokomo?.two_step);
      }
    },
    async getMedicalByUserId() {
      const res = await api.getMedicalByUserId(this.user.id);
      if (res.status === 200 && res.data) {
        this.medical = res.data;
      }
    },
    calcMinutes(timeString) {
      const time = moment(timeString, "HH:mm:ss");

      return Math.round(time.hours() * 60 + time.minutes() + (time.seconds() / 60));
    },
    calcTotalMinutes() {
      return this.suggestVideos.reduce((result, i) => result + this.calcMinutes(i.duration), 0);
    },
    closeModal() {
      this.$emit("close");
    },
    toggleSelectedVideos(id) {
      const index = this.selectedVideoNos.indexOf(id);

      if (index === -1) {
        if (this.selectedVideoNos.length < 3) {
          this.selectedVideoNos.push(id);
        }
      } else {
        this.selectedVideoNos.splice(index, 1);
      }
    },
    openVideoPopup(videoUrl) {
      this.videoUrl = videoUrl;
      this.showVideoFlag = true;
    },
    makeRehabAiRequest() {
      const height = this.rokomo?.two_step_data?.[0]?.height ? Number(this.rokomo?.two_step_data[0].height) : Number(this.medical?.height) || 0;

      return {
        ID: Number(this.user.id) || 0,
        Date: new Date(),
        KL_L: Number(this.rokomo?.kl_left) || 0,
        KL_R: Number(this.rokomo?.kl_right) || 0,
        Age: Number(this.user.information?.age) || 0,
        Gender: Number(this.user.information?.sex) || 0,
        Height: height,
        WBI: Number(this.rokomo?.wbi) || 0,
        twostepvalue: Number(this.rokomo?.two_step) || 0,
        Locomo25Total: Number(this.rokomo?.locomo25_score) || 0,
        Locomo: {
          StandingUp: Number(this.rokomo?.stand_up_choice_value) || 0,
          twoStep: Number(this.rokomo?.two_step_level) || 0,
          Locomo25: Number(this.rokomo?.locomo25_rank) || 0,
          LocomoDegree: (
            (Number(this.rokomo?.stand_up_choice_value) || 0)
            + (Number(this.rokomo?.two_step_level) || 0)
            + (Number(this.rokomo?.locomo25_rank) || 0)
          ),
          LocomoApplicableCount: (
            (this.rokomo?.stand_up_choice_value ? 1 : 0)
            + (this.rokomo?.two_step_level ? 1 : 0)
            + (this.rokomo?.locomo25_rank ? 1 : 0)
          ),
        }
      };
    },
    async callAiGetSuggestions() {
      this.locked = true;

      const request = this.makeRehabAiRequest();

      // 送信処理
      const res = await api.postRCRehabilitationAPI(request);

      if (res.status === 200 && res.data.data.status !== 0) {
        const results = res.data.data.results || [];

        this.suggestVideoNos = this.allRehabVideos
          .filter(video => results.includes(video.code))
          .map(video => video.no);

        this.selectedVideoNos = [...this.suggestVideoNos];
      }

      this.locked = false;
      this.mode = 2;
    },
    async selectSuggestions() {
      this.suggestVideoNos = [...this.selectedVideoNos];
      this.mode = 2;
    },
     validatePayload(payload) {
       this.errors = {};

      if (!payload.title) {
        this.errors.title = 'リハビリメニュー名は必須項目です。';
      }

      if (payload.suggestions.length === 0) {
        this.errors.suggestions = '少なくとも1つのビデオを選択してください！';
      }
    },
    hasError(key = null) {
      return key ? this.errors.hasOwnProperty(key) : !isEmpty(this.errors);
    },
    async saveSuggestions() {
      this.locked = true;

      const payload = {
        "user_id": this.user.id,
        "suggestions": this.suggestVideoNos,
        "title": this.title,
        "submit_at": moment().toISOString(),
        "type": this.type,
        "duration": this.calcTotalMinutes() * 60,
        "rokomo_test_id": this.rokomo?.id
      };

      if (this.isEdit) {
        payload.id = this.rehabVideoSuggestionId;
      }

      this.validatePayload(payload);

      if (this.hasError()) {
        this.locked = false;
        this.loading = false;
        return;
      }

      const action = this.isEdit ? api.updateRehabVideoSuggestion : api.createRehabVideoSuggestion;

      const res = await action(payload);

      if (res.status === 200) {
        this.isEdit ? this.$emit('updated') : this.$emit('created', res.data);
        this.closeModal();
        this.title = '';
        this.locked = true;
        this.loading = true;
        this.mode = 1;
      }
    },
    getSuggestionTypeName() {
      return this.suggestionTypes.find(i => i.value === Number(this.type))?.name;
    },
    async RehabVideoSuggestion() {
      const res = await api.getDetailRehabVideoSuggestion(this.rehabVideoSuggestionId);

      if (res.status === 200) {
        const rehabVideoSuggestion = res.data;
        this.suggestVideoNos = rehabVideoSuggestion.suggestions;
        this.selectedVideoNos = rehabVideoSuggestion.suggestions;
        this.title = rehabVideoSuggestion.title;
        this.type = rehabVideoSuggestion.type;
        this.rokomo = { id: rehabVideoSuggestion.rokomo_test_id };
      }
    },
  },
};
</script>

<style scoped>
::v-deep .modal-header {
  display: none;
}
.video-title-241101 {
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  min-height: 3.6em;
  text-align: justify;
}
</style>
